<template>
    <b-overlay :show="loading" rounded="sm">

        <div class="mb-3 d-flex align-items-start  justify-content-between flex-lg-row flex-column">

            <div class="h5 p-0 m-0">

                Anotações

            </div>

            <div class="d-inline-flex">
                <div class="d-flex align-items-center gap-1">
                    <div>Mostrar Editor ao passar mouse</div>
                    <b-form-checkbox
                            v-model="showAnnotationOnHover"
                            id="showOnHover"
                            switch>
                    </b-form-checkbox>
                </div>
                <div class="btn-group mr-1" role="group" aria-label="Basic example">
                    <span class="badge badge-warning position-absolute" style="z-index: 1000; top: -7px; right: -10px;"
                    v-b-tooltip.hover title="Modo de Anotação"
                    >Novo</span>
                    <button v-for="(mode,index) in annotation_mode" :key="index"
                     type="button"
                     class="btn btn-sm btn-outline-primary"
                     :disabled="essay.status === 'OKAY' || essay.status === 'WAIT' || essay.status === 'BLOCK'"
                     :class="mode.value === annotation_type ?'active' : ''"
                     @click="setMode(mode.value)">
                     <span v-if="mode.value === 'freehand'">
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                            <path stroke-linecap="round" stroke-linejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 0 1 1.13-1.897L16.863 4.487Zm0 0L19.5 7.125" />
                        </svg>
                          
                     </span>
                     <span v-if="mode.value === 'rect'">
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M5.25 7.5A2.25 2.25 0 0 1 7.5 5.25h9a2.25 2.25 0 0 1 2.25 2.25v9a2.25 2.25 0 0 1-2.25 2.25h-9a2.25 2.25 0 0 1-2.25-2.25v-9Z" />
                          </svg>
                          
                     </span>
                     {{mode.name}}
                    </button>

                </div>
                

                <div class="text-primary fw-normal" role="button" @click="rotateEssay">
                <svg class="icons" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" >
                           <path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />
                   </svg>
               Girar 90º
               </div>



            </div>

        </div>

        <div class="mb-3">
            <div id="openSeadragon" class="essayZoom"></div>
        </div>

    </b-overlay>
</template>

<script>
import ColorSelectorWidget from "../../../../mixins/ColorSelectorWidget";
import ModeFieldSelectorWidget from "../../../../mixins/ModeFieldSelectorWidget";
import ColorFormatter from "../../../../mixins/ColorFormatter";
import OpenSeadragon from '@recogito/annotorious-openseadragon/public/openseadragon/openseadragon.3.0.0.min';
import Annotorious from '@recogito/annotorious-openseadragon'
import SelectorPack from '@recogito/annotorious-selector-pack';
import GetColorOfFieldWidget from "../../../../mixins/GetColorOfFieldWidget";


export default {
    props: ['essay', 'modes'],
    data() {
        return {
            loading: false,
            openSeadragonInstance: null,
            annotationInstance: null,
            id: null,
            annotations: [],
            modes: {
                fields: []
            },
            annotation_mode: [
                { name: 'Retângulos', value: 'rect'},
                { name: 'Mão livre', value: 'freehand'},
            ],
            annotation_type: 'rect',
            showAnnotationOnHover: window.sessionStorage.getItem('showAnnotationOnHover'),
        }
    },
    created (){
    },
    mounted() {

        this.id = this.essay.id

        let viewer = OpenSeadragon({
            id: 'openSeadragon',
            prefixUrl: "https://cdnjs.cloudflare.com/ajax/libs/openseadragon/2.4.2/images/",
            tileSources: {
                type: 'image',
                url: this.essay.preview
            },
            gestureSettingsTouch: {
                pinchRotate: true
            },
            constrainDuringPan: true,
            maxZoomPixelRatio: 1.85,
        })

        this.annotationInstance = Annotorious(viewer, {
            locale: 'pt',
            drawOnSingleClick: true,
            disableDeleteKey: true,
            readOnly: this.essay.status === 'OKAY' || this.essay.status === 'WAIT' || this.essay.status === 'BLOCK',
            widgets: [
                (args) => ModeFieldSelectorWidget(args, this.modes),
                (args) => GetColorOfFieldWidget(args, this.modes),
                (args) => ColorSelectorWidget(args),
                {
                    widget: 'COMMENT',
                    endpoint: '/teacher/pre-comments/search'
                }
            ],
            formatters: [ColorFormatter]
        })

        SelectorPack(this.annotationInstance);

        this.annotationInstance.on('createAnnotation', this.createAnnotation)

        this.annotationInstance.on('updateAnnotation', this.updateAnnotation)

        this.annotationInstance.on('deleteAnnotation', this.deleteAnnotation)

        this.annotationInstance.on('mouseEnterAnnotation', (annotation, element)=> {
            if(annotation.hasOwnProperty('id') && this.showAnnotationOnHover === 'true')
            this.annotationInstance.selectAnnotation(annotation);
        })

        // Width Essay
        // this.$refs.essayAnnotation.parentElement.style.width = '100%'

        // Loading Annotations
        this.load()
    },
    watch: {
        showAnnotationOnHover(value){
            window.sessionStorage.setItem('showAnnotationOnHover', value)
            this.showAnnotationOnHover = window.sessionStorage.getItem('showAnnotationOnHover')
        }
    },
    methods: {

        load() {
            this.loading = true;
            axios.get('/teacher/new-annotations/' + this.id)
                .then(async (result) => {
                    const response = result.data.data

                    // Format Annotations
                    let annotations = response.new_annotations.map(element => {

                        // element.data.body.push({
                        //     purpose: "ordering",
                        //     type: "TextualBody",
                        //     value: element.order
                        // })

                        return element.data;
                    })

                    // Clear Actual Annotations
                    for (let i = 0; i < annotations.length; i++) {
                        await this.annotationInstance.removeAnnotation(annotations[i]);
                    }

                    // Set Annotations
                    this.annotationInstance.setAnnotations(annotations)
                    this.annotations = annotations;

                })
                .finally(() => {
                    this.loading = false
                })

        },
        setMode(modeValue){

            this.annotation_type = modeValue
            this.annotationInstance.setDrawingTool(modeValue);
        },
        createAnnotation(annotation) {
            axios.post('/teacher/new-annotations/' + this.id, {
                id: annotation.id,
                data: annotation
            })
                .then(async (result) => {
                    const response = result.data.data

                    // Save Message
                    this.$toast.success('Anotação Salva', {
                        duration: 2000
                    })

                    // Load
                    this.load()

                })
        },

        updateAnnotation(annotation) {
            let id = annotation.id.replace(/#/i, '');

            axios.put('/teacher/new-annotations/' + id, {
                data: annotation
            })
                .then(async (result) => {
                    const response = result.data.data

                    // Save Message
                    this.$toast.success('Anotação Atualizada', {
                        duration: 2000
                    })

                    // Load
                    this.load()

                })
        },

        deleteAnnotation(annotation) {
            let id = annotation.id.replace(/#/i, '');

            axios.delete('/teacher/new-annotations/' + id)
                .then(async (result) => {

                    // Save Message
                    this.$toast.success('Anotação Deletada', {
                        duration: 2000
                    })

                    this.annotationInstance.clearAnnotations();

                    // Load
                    this.load()

                })
        },

        rotateEssay() {
            this.loading = true;

            axios.put('/teacher/essays/' + this.id + '/image-rotate')
                .then(async (result) => {

                    // Save Message
                    this.$toast.success('Imagem Rotacionada', {
                        duration: 2000
                    })

                    // Reload
                    window.location.reload();

                })
                .finally(() => {
                    this.loading = false
                })
        },
        
    }
}
</script>

<style scoped>
.icons{
    height: 16px;
}
.essay {
    width: 100% !important;
}
.essayZoom {
    width: 100%;
    height: 820px;
    border: 2px solid #333;
    border-radius: 5px;
    background-color: #222;
}
</style>
